/**Import react section */
import React, { useState } from 'react'
/**Import common componets */
import ButtonConfirm from '../../common/Buttons/ButtonConfirm'
/**Import MaterialUi section */
import { Grid, Checkbox, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { createServicesStyle } from '../../../resources/styles/CreateServiceStyles'

const useReopenSelectorStyles = makeStyles((theme) => ({
    title: {
        display: 'block',
        marginBottom: theme.spacing(1.5),
        color: theme.palette.text.secondary
    },
    list: {
        display: 'flex',
        flexDirection: 'column'
    },
    group: {
        marginBottom: theme.spacing(1.5)
    },
    groupTitle: {
        display: 'block',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        letterSpacing: '0.03em',
        color: theme.palette.text.secondary,
        paddingBottom: theme.spacing(0.5),
        marginBottom: theme.spacing(0.75),
        borderBottom: `1px solid ${theme.palette.divider}`
    },
    item: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0.5, 1),
        marginBottom: theme.spacing(1),
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    },
    itemCheckbox: {
        pointerEvents: 'none',
        marginRight: theme.spacing(0.5)
    },
    itemText: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    },
    itemCode: {
        fontWeight: 'bold',
        wordBreak: 'break-word'
    },
    itemTracking: {
        color: theme.palette.text.secondary
    }
}))

/**Group the request's spare parts by the equipment serie they belong to */
const groupSparePartsBySerie = (spareParts) => {
    const groups = []
    spareParts.forEach((item) => {
        const serie = item.Equipment ? item.Equipment.Serie : null
        const model = item.Equipment ? item.Equipment.Model : null
        let group = groups.find((existingGroup) => existingGroup.serie === serie)
        if (!group) {
            group = { serie: serie || 'N/A', model, items: [] }
            groups.push(group)
        }
        group.items.push(item)
    })
    return groups
}

const ReopenSparePartsSelector = (props) => {
    const { onSetPasswordDialogConfiguration, sparePart, status } = props
    const classes = createServicesStyle()
    const reopenClasses = useReopenSelectorStyles()
    const [selectedTokens, setSelectedTokens] = useState([])

    const spareParts = sparePart && sparePart.SpareParts ? sparePart.SpareParts : []
    const sparePartGroups = groupSparePartsBySerie(spareParts)

    /**Toggle a spare part token in/out of the current selection */
    const onToggleSparePart = (token) => {
        setSelectedTokens((current) => (current.includes(token) ? current.filter((item) => item !== token) : current.concat(token)))
    }

    const openModalForChangeRequest = () => {
        if (onSetPasswordDialogConfiguration) onSetPasswordDialogConfiguration({ status: status, sparePartTokens: selectedTokens })
    }

    /**Verify if can be confirmed, at least one spare part must be selected */
    const canBeSaved = () => selectedTokens.length > 0

    return (
        <div>
            <Grid item xs={12}>
                <Typography variant="body2" className={reopenClasses.title}>
                    Select which spare part(s) you want to reopen
                </Typography>
                <div className={reopenClasses.list}>
                    {sparePartGroups.map((group) => (
                        <div key={group.serie} className={reopenClasses.group}>
                            <Typography variant="caption" className={reopenClasses.groupTitle}>
                                Serie: {group.serie}
                                {group.model ? ` | ${group.model}` : ''}
                            </Typography>
                            {group.items.map((item) => (
                                <div key={item.Token} className={reopenClasses.item} onClick={() => onToggleSparePart(item.Token)}>
                                    <Checkbox
                                        className={reopenClasses.itemCheckbox}
                                        checked={selectedTokens.includes(item.Token)}
                                        color="primary"
                                        tabIndex={-1}
                                        disableRipple
                                    />
                                    <div className={reopenClasses.itemText}>
                                        <Typography variant="body2" className={reopenClasses.itemCode}>
                                            {item.Code} - {item.Description}
                                        </Typography>
                                        <Typography variant="caption" className={reopenClasses.itemTracking}>
                                            Tracking: {item.NumberTracking || 'N/A'}
                                        </Typography>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </Grid>
            <Grid item xs={12} className={classes.updateButton}>
                <ButtonConfirm title="CONFIRM" isSaving={!canBeSaved()} onSavedClick={openModalForChangeRequest} />
            </Grid>
        </div>
    )
}

export default ReopenSparePartsSelector
